import React from "react";
import { XPosition, YPosition } from "../components/CoverPhoto";
import CoverPhoto from "../components/CoverPhoto";
import Headline from "../components/Headline";
import { css } from "emotion";

import TwoColumn from "../components/TwoColumn";
import TextCard from "../components/Cards/TextCard";
import ImageCard from "../components/Cards/ImageCard";
import TestimonyCard from "../components/Cards/TestimonyCard";
import PieChartCard from "../components/Cards/PieChartCard";
import FinancialAidBarChart from "../components/Cards/FinancialAidBarChart";
import LocationBreakdownPieChartCard from "../components/Cards/LocationBreakdownPieChartCard";
import EthnicityBreakdownBarChartCard from "../components/Cards/EthnicityBreakdownBarChartCard";
import EthnicitySectionBreakdownBarChartCard from "../components/Cards/EthnicitySectionBreakdownBarChartCard";
import InternEthnicityBreakdownBarChartCard from "../components/Cards/InternEthnicityBreakdownBarChartCard";
import InternGenderBreakdownBarChartCard from "../components/Cards/InternGenderBreakdownBarChartCard";
import LocationBreakdownBarChartCard from "../components/Cards/LocationBreakdownBarChartCard";
import TransferStatus from "../components/Cards/TransferComparison";
import AcademicBreakdownBarChartCard from "../components/Cards/AcademicBreakdownBarChartCard";
import LGBTQBreakdownPieChartCard from "../components/Cards/LGBTQBreakdownPieChartCard";
import DisabilityBreakdownPieChartCard from "../components/Cards/disabilityBreakdownPieChartCard"

import { mediaQueries, colors, fonts } from "../shared/config";
interface PageState {
  query: any;
}

const link_style= `
  color: ${colors.darkblue}; 
  text-decoration: none; 
  
  "&:hover": {text-decoration: underline}
  `

export default class Page extends React.Component<{ data: any }, PageState> {
  constructor(props: any) {
    super(props);
    this.state = {
      query: null
    };
  }

  componentDidMount() {
    fetch(
      "https://kerckhoff.dailybruin.com/api/packages/flatpages/diversityreport.2022",
      {
        method: "GET",
        headers: { "Content-Type": "application/json" }
      }
    )
      .then(results => results.json())
      .then(results => this.setState({ query: results }));
  }

  render() {
    const { mobile, notMobile } = mediaQueries;
    if (!this.state.query) return <></>;
    const data = this.state.query.data["site.aml"];
    console.log(data);
    console.log(data.coverPhoto);
    return (
      <>
        {this.props.data && (
          <div
            className={css`
              justify-content: center;
              font-family: sans-serif;
              font-family: ${fonts.textFont};
            `}
          >
            <CoverPhoto
              headline={data.coverTitle}
              description={data.coverBlurb}
              imageURL={data.CoverPhoto}
              darken={0.4}
            />

            <Headline text={data.introTitle} content={data.introBlurb} />

            <article
              className={css`
                margin-left: auto;
                margin-right: auto;
                margin-top: 0;
                max-width: 700px;
                padding: 1rem;
                text-align: justify;
                font-family: sans-serif;
                font-family: ${fonts.textFont};
              `}
              
            >
            For the third consecutive year, the Daily Bruin is reflecting on its progress toward becoming a more diverse and representative center of journalism for the UCLA community. 
            <br></br><br></br>
            At The Bruin, we strive for journalistic excellence – this goal cannot be achieved without having diverse voices in our newsroom. Through diversity, we gain depth and clarity, spotlight complex perspectives and attain greater balance. To that end, the Daily Bruin is continually undergoing the necessary work to become a fully representative and inclusive campus institution. This diversity report will offer transparency on our staff makeup, efforts we have made this year, and what we see as our shortcomings.
            <br></br><br></br>
            Here is what the Daily Bruin did over the past year to improve accessibility and diversity:
            <br></br><br></br>
            The paper has made efforts to highlight the achievements and stories of diverse communities at UCLA by publishing special packages during different heritage months to feature stories from these communities. These packages include:
            <ul>
              <li><a className = {css `${link_style}`} href = 'https://features.dailybruin.com/2021/hispanic-heritage-month/' target = '_blank'>Hispanic Heritage Month</a> in September</li>
              <li><a className = {css `${link_style}`} href = 'https://features.dailybruin.com/2021/native-american-heritage-month/' target = '_blank'>Native American Heritage Month</a> in November</li>
              <li><a className = {css `${link_style}`} href = 'https://features.dailybruin.com/2022/black-history-month/' target = '_blank'>Black History Month</a> in February</li>
              <li>We aim to publish another special package in May dedicated to Asian American and Pacific Islander Heritage Month.</li>
            </ul>
            However, we are particularly cognizant of the fact that producing these packages is not enough to achieve diversity at the paper. Instead it is crucial that editors and writers at all levels of the paper incorporate underrepresented voices in their everyday work. 
            <br></br><br></br>
            We have also created channels on Slack where leaders of community groups with The Bruin, such as Latinos-of-DB and Transfers-of-DB, can have a direct line to management to give input on policy and articulate the needs of these communities.
            <br></br><br></br>
            The Daily Bruin Outreach section, established two years ago, has refreshed its efforts to recruit a more diverse group of students at UCLA, gather community input and understand accessibility needs internally. Over the past year, the office expanded on its operations to:
            <ul>
              <li>Release an intern packet to streamline integration into Daily Bruin</li>
              <li>Continue surveying staff needs and concerns through internal retention surveys</li>
              <li>Solicit feedback from members of the Mother Organizations coalition and Student Media newsmagazines that focus their coverage on marginalized communities</li>
              <li>Regularly conduct community surveys to receive community input</li>
              <li>Engage with clubs and organizations representing underrepresented groups as well as academic departments to recruit interns from diverse backgrounds</li>
              <li>Revamp alumni engagement efforts through social media and host alumni networking events with staffers</li>
            </ul>
            We have retained the tradition, which started last year, of holding an diversity, equity and inclusion training and a transfer awareness training in our new editor onboarding process. We also separately held a mental health resources training with representatives from UCLA Counseling and Psychological Services.
            <br></br><br></br>
            To increase accessibility, we reduced the amount of work some contributors need to put into the Daily Bruin before they are eligible to become paid staffers. 
            <br></br><br></br>
            The 2021-2022 report incorporated additional survey areas compared to previous reports. The 2021-2022 diversity report:
            <ul>
              <li>Surveyed students’ gender identities and sexual orientations</li>
              <li>Surveyed students’ disability statuses</li>
              <li>Surveyed students’ veteran statuses (this graph was not included because only one respondent did not say they were not a veteran and they preferred not to disclose their status)</li>
              <li>Displayed data for paid staffers and editors separately from interns and unpaid contributors</li>
            </ul>
            The data shows that while we are making improvements, the Daily Bruin still has to do a lot more to make itself more diverse and to support the diverse needs of its staff. We also welcome any of your ideas in improving this report. Please contact us via social media, email or op-ed submission.
            </article>
            <TwoColumn>
              {data.layout.map((item: any, i: number) => {
                // console.log(item);
                switch (item.type) {
                  case "image":
                    return <ImageCard value={item.value} />;
                  case "text":
                    return <TextCard text={item.value} />;
                  case "testimony":
                    return <TestimonyCard value={item.value} />;
                  case "piechart":
                    return <PieChartCard caption={item.value.caption[0].value}/>;
                  case "barchart":
                    return <FinancialAidBarChart caption={item.value.caption[0].value}/>;
                  case "locationBreakdown":
                    return <LocationBreakdownBarChartCard caption1={item.value.caption[0].value} caption2= {item.value.caption[1].value}/>;
                  case "ethnicityBreakdown":
                    return <EthnicityBreakdownBarChartCard caption1={item.value.caption[0].value} caption2= {item.value.caption[1].value}/>;
                  case "academicBreakdown":
                    return <AcademicBreakdownBarChartCard caption={item.value.caption[0].value}/>;
                  case "transferStatus":
                    return <TransferStatus caption1={item.value.caption[0].value} caption2= {item.value.caption[1].value}/>;
                  case "LGBTQBreakdown":
                    return <LGBTQBreakdownPieChartCard caption={item.value.caption[0].value}/>;
                  case "disabilityBreakdown":
                    return <DisabilityBreakdownPieChartCard caption={item.value.caption[0].value}/>;
                  default:
                    return <></>;
                }
              })}
            </TwoColumn>
            <div
              className={css`
                width: 70%;
                ${mobile} {
                  width: 100%;
                }
                margin: 0 auto;
              `}
            >
              <EthnicitySectionBreakdownBarChartCard caption={data.ethnicitySectionBreakdown.caption[0].value}/>
            </div>
            <div>
              <h1
                className={css`
                  font-family: sans-serif;
                  font-family: ${fonts.textFont};
                  font-size: 48px;
                  align-items: center;
                  text-align: center;
                  font-weight: 300;
                  margin: 0 10px;
                  margin-top: 80px;

                  color: #3d3d3d;
                `}
              >
                A Look at the Fall 2019, Fall 2020 and Fall 2021 Intern Classes
              </h1>

              <TwoColumn>
                <InternEthnicityBreakdownBarChartCard caption={data.internEthnicityBreakdown.caption[0].value}/>
                <InternGenderBreakdownBarChartCard caption={data.internGenderBreakdown.caption[0].value}/>
              </TwoColumn>
            </div>
            <Headline text={data.analysisTitle} content={data.analysisBlurb} />
            <Headline text={data.outroTitle} content={data.outroBlurb} />
            <article
            className={css`
            margin-left: auto;
            margin-right: auto;
            margin-top: 0;
            margin-bottom: 0;
            max-width: 700px;
            padding: 1rem;
            text-align: justify;
            font-family: sans-serif;
            font-family: ${fonts.textFont};
          `}>

            </article>
            <div
              className={css`
                height: auto;
                text-align: center;
                padding: 10px;
                background-color: ${colors.lightgray};
              `}
            >
              developed by lindsey parungo, laurel woods, mattie sanseverino and andrew kan. design by lauren ho
            </div>
          </div>
        )}
      </>
    );
  }
}
